export default class ProductSubCategoryModel {
  SubCategoryId: number | null;
  CategoryId: number | null;
  CategoryName: string;
  SubCategoryName: string;
  Slug: string;
  ImageUrl: string;
  DisplayOrder: number;
  IsActive: boolean;

  constructor() {
    this.SubCategoryId = null;
    this.CategoryId = null;
    this.CategoryName = '';
    this.SubCategoryName = '';
    this.Slug = '';
    this.ImageUrl = '';
    this.DisplayOrder = 0;
    this.IsActive = true;
  }
}
